import { Catalog as e } from "./Catalog.js";
import { CatalogSearch as t } from "./CatalogSearch.js";
import { FacetCollectionConfigurations as n } from "./FacetCollectionConfigurations.js";
import { FacetFieldConfigurations as r } from "./FacetFieldConfigurations.js";
import { FacetPerformanceReportingMetrics as i } from "./FacetPerformanceReportingMetrics.js";
import { FeatureStackConfiguration as a } from "./FeatureStackConfiguration.js";
import { ListingPage as o } from "./ListingPage.js";
import { ProductListingConfiguration as s } from "./ProductListingConfiguration.js";
import { ProductListingReportingMetrics as c } from "./ProductListingReportingMetrics.js";
import { RecommendationSlotPreview as l } from "./RecommendationSlotPreview.js";
import { RecommendationsMetrics as u } from "./RecommendationsMetrics.js";
import { RuleDefinition as d } from "./RuleDefinition.js";
import { RulePreview as f } from "./RulePreview.js";
import { Rules as p } from "./Rules.js";
import { SearchMetrics as m } from "./SearchMetrics.js";
import { SlotConfiguration as h } from "./SlotConfiguration.js";
import { SynonymRulePreview as g } from "./SynonymRulePreview.js";
import { Synonyms as _ } from "./Synonyms.js";
import { TrackingIdLocales as v } from "./TrackingIdLocales.js";
import { Setup as y } from "./Setup.js";
import { Audiences as b } from "./Audiences.js";
import { RuleCount as x } from "./RuleCount.js";
import { CatalogFields as S } from "./CatalogFields.js";
import { Resource as C } from "@coveo/platform-client";
//#region src/resources/commerce/Commerce.ts
var w = class extends C {
	constructor(C, w) {
		super(C, w), this.api = C, this.serverlessApi = w, this.audiences = new b(C, w), this.productListingReportingMetrics = new c(C, w), this.productListingConfigurationsV2 = new s(C, w), this.searchMetrics = new m(C, w), this.trackingIdLocales = new v(C, w), this.slotConfiguration = new h(C, w), this.recommendationMetrics = new u(C, w), this.recommendationSlotPreview = new l(C, w), this.rules = new p(C, w), this.synonymRulePreview = new g(C, w), this.synonyms = new _(C, w), this.catalogSearch = new t(C, w), this.catalog = new e(C, w), this.catalogFields = new S(C, w), this.facetCollectionConfigurations = new n(C, w), this.facetPerformanceReportingMetrics = new i(C, w), this.facetFieldConfigurations = new r(C, w), this.ruleDefinition = new d(C, w), this.rulePreview = new f(C, w), this.setup = new y(C, w), this.listingPage = new o(C, w), this.ruleCount = new x(C, w), this.featureStackConfiguration = new a(C, w);
	}
};
//#endregion
export { w as CommerceResource };

//# sourceMappingURL=Commerce.js.map